var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0597 0C4.28035 0 -0.338446 6.72387 2.21937 12.8694L3.31285 15.4966C3.4107 15.7317 3.33917 16.0018 3.13697 16.1608L0.824727 17.9784C0.630706 18.1309 0.556152 18.3867 0.638742 18.6165C0.721331 18.8463 0.943078 19 1.19192 19H10.3638C16.0201 19 20.6055 14.5116 20.6055 8.97494C20.6055 4.01822 16.5004 0 11.4366 0H11.0597Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0597 0C4.28035 0 -0.338446 6.72387 2.21937 12.8694L3.31285 15.4966C3.4107 15.7317 3.33917 16.0018 3.13697 16.1608L0.824727 17.9784C0.630706 18.1309 0.556152 18.3867 0.638742 18.6165C0.721331 18.8463 0.943078 19 1.19192 19H10.3638C16.0201 19 20.6055 14.5116 20.6055 8.97494C20.6055 4.01822 16.5004 0 11.4366 0H11.0597Z",
    fill: "url(#paint0_linear_47_1547)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_1547",
    x1: 10.5804,
    y1: 2.19624,
    x2: 10.5804,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4201FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9954F0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.1d6cbe9f040eed08bc10cd02ad7d3be5.svg";
export { ForwardRef as ReactComponent };